/**
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const ManagemntQueryKeys = {
  all: ['user'] as const,
  lists: () => [...ManagemntQueryKeys.all, 'list'] as const,
  list: (filters: object) =>
    [...ManagemntQueryKeys.lists(), { filters }] as const,
  details: () => [...ManagemntQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...ManagemntQueryKeys.details(), id] as const,
};
